import { useEffect } from "react";
import func from "@uikit/func";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { useSelector } from "react-redux";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";

/**
 * 用于挂载 container 的初始逻辑
 *
 * 目前包含以下：
 *
 * - 包含了 webConfig 初始化
 *
 */
export function useContainerMounted() {
  const feature_tags = useFeatureTags();
  const templateObj = useSelector((state: any) => state.studio.selectedTemplate);

  useEffect(() => {
    creatorRefStore.isNewEdgeRunRef.current = !func.isEmpty(templateObj?.v3) || templateObj?.isV3Function || false;
  }, [templateObj, feature_tags]);
}
